import { useParams } from "react-router-dom";
import { useTrackTabAccess } from "../../../../../../../api/services/tabs.hooks";
import { is402Error } from "../../../../../../../api/utils/error.utils";
import { LockDisplay } from "../../../../../../components/LockDisplay/LockDisplay";
import { AkindaRankingScore } from "../Ranking/components/AkindaRankingScore";
import { ShariahReportFaq } from "../ShariahReport/ShariahReportFaq";
import { RelatedHalalStocks } from "./component/RelatedHalalStocks";
import { ShariahSummaryCard } from "./component/ShariahSummaryCard";
import { CompanyProfile } from "./component/CompanyProfile";
import { KeyStatsTable } from "./component/KeyStatsTable";
import { SwotAnalyzTable } from "./component/SwotAnalyzTable";
import TradingViewWidget from "./component/TradingViewWidget";
import styles from "./index.module.css";

export default function Summary() {
  const { symbol = "AAPL" } = useParams<{ symbol: string }>();
  const tabType = "summary";
  const { data, error } = useTrackTabAccess(tabType, symbol);

  const token = (data?.data as Record<string, unknown>)?.token ?? data?.data;
  const showLockDisplay = error ? is402Error(error) : false;
  const tabAccessToken = typeof token === "string" ? token : undefined;

  return (
    <div className={styles.contentWrapper}>
      <ShariahSummaryCard ticker={symbol.toUpperCase()} />
      {showLockDisplay ? (
        <LockDisplay status={402} height="400px" />
      ) : (
        <>
          <div className={styles.dashboardGrid}>
            <div className={styles.gridCell}>
              <div className={styles.chartCard}>
                <div className={styles.chartInner}>
                  <TradingViewWidget symbol={symbol} />
                </div>
              </div>
            </div>
            <div className={styles.gridCell}>
              <div className={styles.rankingCell}>
                <AkindaRankingScore tabAccessToken={tabAccessToken} />
              </div>
            </div>
            <div className={styles.gridCell}>
              <div className={styles.bottomCell}>
                <KeyStatsTable tabAccessToken={tabAccessToken} />
              </div>
            </div>
            <div className={styles.gridCell}>
              <div className={styles.bottomCell}>
                <SwotAnalyzTable tabAccessToken={tabAccessToken} />
              </div>
            </div>
          </div>
          <CompanyProfile tabAccessToken={tabAccessToken} />
        </>
      )}
      <ShariahReportFaq />
      <RelatedHalalStocks ticker={symbol.toUpperCase()} />
    </div>
  );
}
